<!-- Vue component -->
<template>
<div id="big-box" class="mapz1">
    <div id="mis-search-box">
        <div id="search_pilot">
            <button v-scroll-to="{ el: value.value, onDone: onDone, offset: -150 }"> 前往 {{ value.name }} 👆</button>
        </div>
        <label class="typo__label">輸入任務名稱，或下拉選擇。再點擊上方的按鍵↑</label>
        <multiselect v-model="value" placeholder="尋找任務" label="name" track-by="desc" :options="options" :option-height="104" :custom-label="customLabel" >
            <template slot="singleLabel" slot-scope="props"><span class="option__desc"><span class="option__name">{{ props.option.desc }} @ {{ props.option.name }}</span></span></template>
            <template slot="option" slot-scope="props">
                <div class="option__desc"><span class="option__desc">{{ props.option.desc }}</span> @ <span class="option__name">{{ props.option.name }}</span></div>
            </template>
        </multiselect>
    </div>
    <div id="hot_list" class="pick-box">
        <div class="box-list">
            <div class="box-head"><h2>快速搜查</h2></div>
            <div class="box-body">
                <template v-for="pack in pepperlist.floders">
                <div class="drawer" >
                    <div class="drawer-head" v-on:click="DrawClass = pack.title"><h4>{{pack.title}}</h4></div>
                    <div class="drawer-body" v-bind:class="{open_draw: DrawClass == pack.title }">
                        <template v-for="item in pack.list">
                        <div class="raid-card">
                            <div v-scroll-to="{ el: item.value, offset: -150 }" v-on:click="IsActive = item.value" class="card-body"><img :src="item.imagepath"/></div>
                        </div>                 
                        </template>
                    </div>
                </div>
                </template>
            </div>
        </div>
    </div>

    <div id="island_map">
        <div id="area_Phantagrande">
            <div class="boarder_Phantagrande islad_Phantagrande"></div>
            <div id="area_Phantagrande_west">
                <div id="Zinkenstill" v-bind:class="{ light_on: '#Zinkenstill' == IsActive }" class="islad_Phantagrande " ><span class="island_name_display">ザンクティンゼル</span></div>
                <div id="Port_Breeze_Archipelago" v-bind:class="{ light_on: '#Port_Breeze_Archipelago' == IsActive }"  ref="#Port_Breeze_Archipelago" class="islad_Phantagrande"><span class="island_name_display">ポート・ブリーズ群島</span></div>
                <div id="Valtz_Duchy" v-bind:class="{ light_on: '#Valtz_Duchy' == IsActive }" class="islad_Phantagrande" ><span class="island_name_display">バルツ公国</span></div>
                <div id="Auguste_Isles" v-bind:class="{ light_on: '#Auguste_Isles' == IsActive }" class="islad_Phantagrande" ><span class="island_name_display">アウギュステ列島</span></div>
                <div id="Lumacie_Archipelago" v-bind:class="{ light_on: '#Lumacie_Archipelago' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">ルーマシー群島</span></div>
                <div id="Albion_Citadel" v-bind:class="{ light_on: '#Albion_Citadel' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">城塞都市アルビオン</span></div>
            </div>
            <div class="boarder_Phantagrande islad_Phantagrande"></div>
            <div class="boarder_Phantagrande islad_Phantagrande"></div>
            <div id="area_Phantagrande_east">
                <div id="Silverwind_Stretch_North_Vast" v-bind:class="{ light_on: '#Silverwind_Stretch_North_Vast' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">白風の境</span></div>
                <div id="Agastia" v-bind:class="{ light_on: '#Agastia' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">帝都アガスティア</span></div>
                <div id="Former_Capital_Mephorash" v-bind:class="{ light_on: '#Former_Capital_Mephorash' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">旧王都メフォラシュ</span></div>
                <div id="Amalthea_Island" v-bind:class="{ light_on: '#Amalthea_Island' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">アマルティア島</span></div>
                <div id="Golonzo_Island" v-bind:class="{ light_on: '#Golonzo_Island' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">ガロンゾ島</span></div>
                <div id="Mist_Shrouded_Isle" v-bind:class="{ light_on: '#Mist_Shrouded_Isle' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">霧に包まれた島</span></div>
                <div id="Dydroit_Belt" v-bind:class="{ light_on: '#Dydroit_Belt' == IsActive }" class="islad_Phantagrande"><span class="island_name_display">ダイダロイトベルト</span></div>
            </div>
            <div class="boarder_Phantagrande islad_Phantagrande"></div>
        </div>

        <div class="screen_switch"><span class=" islad_Nalhegrande sky_medal"></span></div>
        <div class="screen_switch"></div>
        <div id="area_Nalhegrande">
            <div id="area_Nalhegrande_west">
                <div id="The_Edgelands" v-bind:class="{ light_on: '#The_Edgelands' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">境界の世界</span></div>
                <div id="Groz_Island" v-bind:class="{ light_on: '#Groz_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">グロース島</span></div>
                <div id="Kluger_Island" v-bind:class="{ light_on: '#Kluger_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">クルーガー島</span></div>
                <div id="Merkmal_Island" v-bind:class="{ light_on: '#Merkmal_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">メルクマール島</span></div>
            </div>
            <div class="boarder_Nalhegrande islad_Nalhegrande"></div>
            <div class="boarder_Nalhegrande islad_Nalhegrande"></div>
            <div id="area_Nalhegrande_east">
                <div id="Starke_Island" v-bind:class="{ light_on: '#Starke_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">シュテルケ島</span></div>
                <div id="Reiche_Island" v-bind:class="{ light_on: '#Reiche_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">ライヒェ島</span></div>
                <div id="Bestia_Island" v-bind:class="{ light_on: '#Bestia_Island' == IsActive }" class="islad_Nalhegrande"><span class="island_name_display">ベスティエ島</span></div>
            </div>
            <div class="boarder_Nalhegrande islad_Nalhegrande"></div>
        </div>
    </div>
</div>
</template>

<script>
import { MissionList } from "../gbf-index.js";
import { PepperList } from "../gbf-index.js";

export default {
  components: {},
  data: function() {
    return {
      DrawClass: null,
      IsActive: null,
      value: { name: "境界の世界", value: "#The_Edgelands", desc: "ダーク・ラプチャー"},
      options: MissionList,
      pepperlist: PepperList
    };
  },
  methods: {
    customLabel({ name, desc }) {
      return `${desc} @ ${name}`;
    },
    onDone() {
      this.IsActive = this.value.value;
    }
  }
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/**  your styles **/

.mapz1 {
  width: 100%;
  height: 100%;
  background: url("https://i.imgur.com/UCSF07t.jpg");
  background-repeat: no-repeat;
}
#search_pilot {
  padding: 4% 3% 4% 0%;
  display: block;
}
#search_pilot button {
  padding: 1%;
  font-size: 1em;
}
#search_pilot span {
  color: brown;
  text-shadow: -1px 0.1em burlywood, 0.1em 1px burlywood, 1px 0.1em burlywood;
}
#mis-search-box {
  padding-bottom: 2%;
}
.typo__label {
  font-size: 1em;
  text-shadow: -1px 0.1em #150f0f, 0.1em 1px #150f0f, 1px 0.1em #150f0f;
}

.multiselect{
  padding-top: 2%;
}
/* quick box */
.pick-box {
  background: rgba(0, 0, 0, 0.65);
  padding-bottom: 2%;
  overflow: hidden;
}
.box-list {
  padding-bottom: 2%;
}
.drawer {
  margin: 0 2% 2% 2%;
  overflow: hidden;
  padding-top: 0px;
  padding-bottom: 2%;
}
.drawer-body {
  display: none;
}
.drawer-head {
  margin: 0 2% 2% 0;
  border: ridge #fcfcfc 1px;
}
.open_draw {
  display: block;
}
h4 {
  margin-left: 2em;
  text-align: left;
  margin-top: 1%;
  margin-bottom: 2%;
}
.raid-card {
  margin: 0 1% 0 1%;
  float: left;
}
.card-head {
  color: #150f0f;
}
.card-body {
  background-color: #150f0f;
}
.card-body img {
  max-width: 90px;
  max-height: 63px;
}

/* world map */
#toTop {
  position: fixed;
  bottom: 2%;
  right: 2%;
  cursor: pointer;
  display: none;
}
.light_on {
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.55);
}
#island_map {
  background: url("https://i.imgur.com/UCSF07t.jpg");
  text-shadow: -1px 0.1em black, 0.1em 1px black, 1px 0.1em black;
}
#area_Phantagrande {
  background: url("https://i.imgur.com/aQvEUo7.jpg");
}
.islad_Phantagrande {
  background-image: url("https://i.imgur.com/rMDjNXH.png");
  display: block;
  position: relative;
}
.island_name_display {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 0;
  color: aliceblue;
  text-shadow: 1px 1px 1px #000, 3px 3px 3px rgb(90, 40, 20),
    2px 2px 2px rgb(90, 40, 20), -1px -1px 2px black;
}
#Zinkenstill {
  margin: 0% 0% 0% 70%;
  height: 100px;
  width: 150px;
  background-position: 160px -1435px;
}
#Port_Breeze_Archipelago {
  margin: 0% 0% 0% 8%;
  height: 100px;
  width: 180px;
  background-position: 320px -1280px;
}
#Valtz_Duchy {
  margin: 0% 0% 0% 50%;
  height: 100px;
  width: 180px;
  background-position: 980px -1810px;
}
#Auguste_Isles {
  margin: 0% 0% 0% 3%;
  height: 100px;
  width: 180px;
  background-position: 980px -1605px;
}
#Lumacie_Archipelago {
  margin: 0% 0% 0% 65%;
  height: 100px;
  width: 180px;
  background-position: 430px -960px;
}
#Albion_Citadel {
  margin: 0% 0% 0% 25%;
  height: 110px;
  width: 180px;
  background-position: 630px -1505px;
}
.boarder_Phantagrande {
  height: 395px;
  background-position: 0px 0px;
}
#Silverwind_Stretch_North_Vast {
  margin: 0% 0% 0% 65%;
  height: 120px;
  width: 180px;
  background-position: 680px -1030px;
}
#Agastia {
  margin: 0% 0% 0% 20%;
  height: 130px;
  width: 190px;
  background-position: 610px -1180px;
}
#Former_Capital_Mephorash {
  margin: 0% 0% 0% 65%;
  height: 150px;
  width: 200px;
  background-position: 550px -1635px;
}
#Amalthea_Island {
  margin: 0% 0% 0% 5%;
  height: 140px;
  width: 200px;
  background-position: 370px -1105px;
}
#Golonzo_Island {
  margin: 0% 0% 0% 68%;
  height: 110px;
  width: 180px;
  background-position: 190px -755px;
}
#Mist_Shrouded_Isle {
  margin: 0% 0% 0% 20%;
  height: 100px;
  width: 150px;
  background-position: 380px -1525px;
}
#Dydroit_Belt {
  margin: 0% 0% 0% 20%;
  height: 140px;
  width: 515px;
  background-position: -100px -505px;
}

/* area_Nalhegrande */
.islad_Nalhegrande {
  background-image: url("https://i.imgur.com/ofnFxpY.png");
  display: block;
  position: relative;
}

#The_Edgelands {
  margin: 0% 0% 0% 3%;
  height: 300px;
  width: 500px;
  background-position: 1020px -9px;
}
#Groz_Island {
  margin: 0% 0% 0% 10%;
  height: 150px;
  width: 270px;
  background-position: 1020px -805px;
}
#Kluger_Island {
  margin: 0% 0% 0% 70%;
  height: 150px;
  width: 160px;
  background-position: 170px -335px;
}
#Merkmal_Island {
  margin: 0% 0% 0% 5%;
  height: 120px;
  width: 180px;
  background-position: 320px -1105px;
}
#Starke_Island {
  margin: 0% 0% 0% 20%;
  height: 155px;
  width: 350px;
  background-position: 480px -960px;
}
#Reiche_Island {
  margin: 0% 0% 0% 60%;
  height: 110px;
  width: 200px;
  background-position: 385px -380px;
}
#Bestia_Island {
  margin: 0% 0% 0% 15%;
  height: 120px;
  width: 180px;
  background-position: 225px -785px;
}
.boarder_Nalhegrande {
  height: 295px;
  width: 570px;
  background-position: -0px -500px;
}
#area_Nalhegrande {
  width: 100%;
  height: 100%;
  background: url("https://i.imgur.com/cz72V6v.jpg");
}
.screen_switch {
  width: 100%;
  height: 50px;
  background-color: black;
}
.sky_medal {
  position: relative;
  width: 110px;
  height: 110px;
  margin-left: 40%;
  margin-bottom: 50px;
  background-position: -900px -925px;
}
</style>